module.exports = __webpack_public_path__ + "img/client-coco-bambu.7e7b7b9e.jpg";